const colors = {
  sky_blue: '#65C7E8',       // Default sky blue
  shamrock_green: '#2B9B52', // Default shamrock green
  champagne: '#FDE6C7',      // Default champagne
  sandy_brown: '#F49C50',    // Default sandy brown
  black: '#010001',          // Default black
  carrot_orange: '#EA8D0C',  // Default carrot orange
  polynesian_blue: '#054B8B',// Default polynesian blue
  jonquil: '#FBCA12',
  shamrock_green_soft: 'rgba(43,155,82,0.73)' // Default jonquil
} as const;

export default colors;